import React from 'react'
import {usePageTitle} from '../hooks/use-page-title'
import {Layout} from "../app/layout";
import {Container} from 'tabler-icons-react';

export const Home = () => {

  usePageTitle('Личный кабинет адвоката')

  return (
    <Layout>
      <Container height={'100%'}>
      </Container>
    </Layout>
  )
}
